import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0f8ec032&scoped=true&lang=pug&"
import script from "./Landing.vue?vue&type=script&lang=ts&"
export * from "./Landing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ec032",
  null
  
)

export default component.exports